import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    
    // Only log in development
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    
    // LATER: In production, you could send to error reporting service
    if (process.env.NODE_ENV === 'production') {
      // Example: Send to Sentry, LogRocket, etc.
      // errorReportingService.captureException(error, { extra: errorInfo });
    }
  }

  render() {
    if (this.state.hasError) {
      // Check if this is a modal-related component and provide recovery
      const isModalError = this.props.fallbackType === 'modal';
      const isSimulatorError = this.props.fallbackType === 'simulator';
      
      if (isModalError) {
        return (
          <div style={{ 
            position: 'fixed', 
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)',
            background: 'rgba(0,0,0,0.9)', 
            color: '#fff', 
            padding: '20px', 
            borderRadius: '8px',
            textAlign: 'center',
            zIndex: 10000 
          }}>
            <h3>Navigation Error</h3>
            <p>Something went wrong with the menu.</p>
            <button 
              onClick={() => window.location.reload()} 
              style={{
                background: '#2596be',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Restart App
            </button>
          </div>
        );
      }
      
      if (isSimulatorError) {
        return (
          <div style={{ 
            color: '#fff', 
            padding: '40px', 
            textAlign: 'center',
            background: 'rgba(0,0,0,0.7)',
            borderRadius: '8px',
            margin: '20px'
          }}>
            <h3>Simulator Error</h3>
            <p>This mode crashed. Try switching to the other mode.</p>
          </div>
        );
      }

      // Default fallback
      return (
        <div style={{ color: 'red', padding: 20, background: '#f9f9f9' }}>
          <h2>Something went wrong.</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
